module.exports = __webpack_public_path__ + "assets/31980deaaa89f6f7468386f6f969a032.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/reel_start.mp3
 ** module id = 465
 ** module chunks = 0
 **/